import { Warning } from "@mui/icons-material";
import { Alert, Box, Typography } from "@mui/joy";
import { ApiQuest, ApiQuestDetail } from "griptonite-api-client/types";
import { useMemo } from "react";

import getPublishWarnings, { useHideWarningsMap } from "./getPublishWarnings";

export default function PublishWarningsAlert({
  tab,
  quest,
}: {
  tab: string;
  quest?: ApiQuest | ApiQuestDetail;
}) {
  const warnings = useMemo(() => getPublishWarnings(quest).byTab[tab], [quest, tab]);
  const hideWarningsMap = useHideWarningsMap(quest?.uuid);

  if (hideWarningsMap[tab] || !warnings?.length) {
    return null;
  }
  return (
    <Alert color="warning" sx={{ marginBottom: 1 }}>
      <Warning />
      <Box>
        <Typography level="title-sm">
          To publish your quest, please fix the following issue
          {warnings.length > 1 ? "s" : ""}:
        </Typography>
        <ul style={{ margin: 0, fontWeight: "bold", paddingLeft: "1.5rem" }}>
          {warnings.map((warning) => (
            <li key={warning.message}>{warning.message}</li>
          ))}
        </ul>
      </Box>
    </Alert>
  );
}
